"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
exports.__esModule = true;
var React = require("react");
var GoogleMapContext_1 = require("../context/GoogleMapContext");
var operation_1 = require("../googlemap/operation");
var googleMapRoute = function (props) {
    var _a = React.useContext(GoogleMapContext_1.GoogleMapContext), map = _a.map, zoom = _a.zoom, bound = _a.bound, setBound = _a.setBound;
    var _b = React.useState(null), mapObject = _b[0], setMapObject = _b[1];
    var mapObjectRef = React.useRef(null);
    var createRoute = function () { return __awaiter(_this, void 0, void 0, function () {
        var lineOpts, polyline;
        return __generator(this, function (_a) {
            if (typeof google === 'undefined')
                return [2 /*return*/];
            lineOpts = {
                path: props.route
            };
            polyline = new google.maps.Polyline(lineOpts);
            polyline.setMap(map);
            setMapObject(polyline);
            operation_1.mapAddObject(map, polyline);
            mapObjectRef.current = polyline;
            return [2 /*return*/, polyline];
        });
    }); };
    React.useEffect(function () {
        return function () {
            // umount mapObject using ref
            if (mapObjectRef.current)
                operation_1.mapRemoveRoute(mapObjectRef.current);
        };
    }, []);
    React.useEffect(function () {
        if (bound) {
            if (zoom === -1) {
                props.route.map(function (it) {
                    bound.extend(it);
                });
                setBound(bound);
                map.fitBounds(bound);
            }
        }
    }, [zoom]);
    var renderContent = function () {
        if (!mapObject)
            createRoute();
        return null;
    };
    return map ? renderContent() : null;
};
exports.GoogleMapRoute = googleMapRoute;
